<template>
    <div class="col-xs-10 col-xs-offset-1">
        <div class="form-group">
            <select v-model="paramsLocal" class="form-control">
                <option v-for="option in field.options" :value="getValue(option)">{{getLabel(option)}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['params', 'field'],
        name: 'SearchSelect',
        data () {
            return {
            }
        },
        computed: {
            paramsLocal: {
                get () {
                    return this.params
                },
                set (newValue) {
                    this.$emit('update:params', newValue)
                }
            }
        },
        methods: {
            getValue (option) {
                return option.value || option
            },
            getLabel (option) {
                return option.label || option
            }
        },
        created () {
            if (this.params === null) {
                this.$emit('update:params', '')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SearchSelect.vue?7190e8eb